"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsEventNames = exports.AnalyticsEventStateEnum = exports.AnalyticsEventDomainEnum = void 0;
var AnalyticsEventDomainEnum;
(function (AnalyticsEventDomainEnum) {
    AnalyticsEventDomainEnum["AUTH"] = "auth";
    AnalyticsEventDomainEnum["AI_IMPORT"] = "ai_import";
    AnalyticsEventDomainEnum["PROJECT"] = "project";
    AnalyticsEventDomainEnum["BRANDING"] = "branding";
    AnalyticsEventDomainEnum["RESOURCE"] = "resource";
    AnalyticsEventDomainEnum["FONT"] = "font";
    AnalyticsEventDomainEnum["TEMPLATE"] = "template";
    AnalyticsEventDomainEnum["MEMBER"] = "member";
})(AnalyticsEventDomainEnum || (exports.AnalyticsEventDomainEnum = AnalyticsEventDomainEnum = {}));
var AnalyticsEventStateEnum;
(function (AnalyticsEventStateEnum) {
    AnalyticsEventStateEnum["STARTED"] = "started";
    AnalyticsEventStateEnum["COMPLETED"] = "completed";
    AnalyticsEventStateEnum["FAILED"] = "failed";
    AnalyticsEventStateEnum["CREATED"] = "created";
    AnalyticsEventStateEnum["SENT"] = "sent";
    AnalyticsEventStateEnum["SUBMITTED"] = "submitted";
    AnalyticsEventStateEnum["VIEWED"] = "viewed";
    AnalyticsEventStateEnum["EDITED"] = "edited";
    AnalyticsEventStateEnum["UPLOADED"] = "uploaded";
    AnalyticsEventStateEnum["SAVED"] = "saved";
    AnalyticsEventStateEnum["ACCEPTED"] = "accepted";
})(AnalyticsEventStateEnum || (exports.AnalyticsEventStateEnum = AnalyticsEventStateEnum = {}));
exports.AnalyticsEventNames = {
    AI_IMPORT_FROM_MARKDOWN_IMPORT_STARTED: 'ai_import.from_markdown_import.started',
    AI_IMPORT_FROM_MARKDOWN_IMPORT_COMPLETED: 'ai_import.from_markdown_import.completed',
    AI_IMPORT_FROM_MARKDOWN_IMPORT_FAILED: 'ai_import.from_markdown_import.failed',
    AI_IMPORT_TASK_CREATED: 'ai_import.task.created',
    AI_IMPORT_STORYBOARD_GENERATION_STARTED: 'ai_import.storyboard_generation.started',
    AI_IMPORT_STORYBOARD_GENERATION_COMPLETED: 'ai_import.storyboard_generation.completed',
    AI_IMPORT_STORYBOARD_GENERATION_FAILED: 'ai_import.storyboard_generation.failed',
    AI_IMPORT_COURSE_GENERATION_STARTED: 'ai_import.course_generation.started',
    AI_IMPORT_COURSE_GENERATION_COMPLETED: 'ai_import.course_generation.completed',
    AI_IMPORT_COURSE_GENERATION_FAILED: 'ai_import.course_generation.failed',
    AUTH_SIGNUP_STARTED: 'auth.signup.started',
    AUTH_SIGNUP_SUBMITTED: 'auth.signup.submitted',
    AUTH_SIGNUP_COMPLETED: 'auth.signup.completed',
    AUTH_SIGNUP_FAILED: 'auth.signup.failed',
    AUTH_EMAIL_CONFIRMATION_SENT: 'auth.email_confirmation.sent',
    AUTH_EMAIL_CONFIRMATION_COMPLETED: 'auth.email_confirmation.completed',
    AUTH_LOGIN_STARTED: 'auth.login.started',
    AUTH_LOGIN_COMPLETED: 'auth.login.completed',
    AUTH_LOGIN_FAILED: 'auth.login.failed',
    AUTH_PASSWORD_RESET_SENT: 'auth.password_reset.sent',
    AUTH_PASSWORD_RESET_COMPLETED: 'auth.password_reset.completed',
    PROJECT_CREATION_COMPLETED: 'project.creation.completed',
    PROJECT_PUBLIC_LINK_STARTED: 'project.public_link.started',
    PROJECT_PUBLIC_LINK_SENT: 'project.public_link.sent',
    PROJECT_COMMENT_LINK_SENT: 'project.comment_link.sent',
    PROJECT_COMMENT_LINK_STARTED: 'project.comment_link.started',
    PROJECT_EXPORT_COMPLETED: 'project.export.completed',
    PROJECT_EXPORT_FAILED: 'project.export.failed',
    BRANDING_CREATION_COMPLETED: 'branding.creation.completed',
    BRANDING_BRANDING_VIEWED: 'branding.branding.viewed',
    BRANDING_BRANDING_EDITED: 'branding.branding.edited',
    RESOURCE_FILE_UPLOADED: 'resource.file.uploaded',
    FONT_FILE_UPLOADED: 'font.file.uploaded',
    TEMPLATE_TO_COLLECTION_SAVED: 'template.to_collection.saved',
    MEMBER_INVITE_SENT: 'member.invite.sent',
    MEMBER_INVITE_ACCEPTED: 'member.invite.accepted',
    MEMBER_INVITE_FAILED: 'member.invite.failed',
};
